import { SubscriptionRepositoryInterface } from "@/data/persistences/repositories/contracts/SubscriptionRepositoryInterface"
import ApiService from "../../services/ApiService"
import { Subscription, Subscriptions } from "@/domain/entities/Subscription"
import { Endpoints } from "../../misc"
import { SubscriptionMapper } from "@/data/persistences/mappers/SubscriptionMapper"
import { CreateSubscriptionRequestInterface } from "@/data/payload/api/SubscriptionRequest"

export class SubscriptionApiRepository
    implements SubscriptionRepositoryInterface {
    private service: ApiService
    private mapper: SubscriptionMapper

    constructor(
        service: ApiService,
        mapper: SubscriptionMapper
    ) {
        this.service = service
        this.mapper = mapper
    }

    public async getAll(params: Map<string, any>): Promise<Subscriptions> {
        const resp = await this.service.invoke(
            'get',
            Endpoints.Route.SUBSCRIPTION,
            params
        )

        return this.mapper.convertSubscriptionsFromApi(resp)
    }

    public async get(subscriptionId: string): Promise<Subscription> {
        const resp = await this.service.invoke(
            'get',
            `${Endpoints.Route.SUBSCRIPTION}/${subscriptionId}`
        )

        return this.mapper.convertSubscriptionDetailFromApi(resp)
    }

    public async delete(subscriptionId: string): Promise<boolean> {
        await this.service.invoke(
          'delete',
          `${Endpoints.Route.SUBSCRIPTION}/${subscriptionId}`,
          undefined
        )
    
        return true
      }

    public async createSubscription(payload: CreateSubscriptionRequestInterface): Promise<boolean> {
        await this.service.invoke(
            'post',
            Endpoints.Route.SUBSCRIPTION,
            undefined,
            payload as CreateSubscriptionRequestInterface,
            new Map([
              [
                'Content-Type',
                'multipart/form-data; ------WebKitFormBoundary7MA4YWxkTrZu0gW',
              ],
            ])
        )
        return true
    }

    public async update(id: string, payload: CreateSubscriptionRequestInterface): Promise<boolean> {
        await this.service.invoke(
          'put',
          `${Endpoints.Route.SUBSCRIPTION}/${id}`,
          undefined,
          payload,
          new Map([
            [
              'Content-Type',
              'multipart/form-data; ------WebKitFormBoundary7MA4YWxkTrZu0gW',
            ],
          ])
        )
        return true
      }
}